import WsService from "../WsService";
import ChatConversationDTO from "../../domain/Chat/ChatConversationDTO";
import CountResponse from "../../domain/CountResponse";

const ENDPOINT_BASE = '/chat/conversation';

export default class ChatConversationService {

    static createConversation(chatConversationCreateRequestDTO) {

        return WsService.post(ENDPOINT_BASE, chatConversationCreateRequestDTO, 201).then(
            response => {
                return new ChatConversationDTO(response);
            },
            response => {
                return response;
            }
        );
    }

    static retrieveAllForUserAndContext(userId, resourceType, resourceId) {

        let params = {
            'resource-type': resourceType,
            'resource-id': resourceId,
            'user-id': userId,
        }

        let url = ENDPOINT_BASE;

        return WsService.get(url, params, 200).then(
            response => {
                let conversations = [];
                response.forEach(conversation => {
                    conversations.push(new ChatConversationDTO(conversation))
                })
                return conversations;
            },
            error => {
                return error;
            }
        )
    }

    static retrieveOpenForUser(userId) {
        let params = {
            'user-id': userId,
        }

        let url = ENDPOINT_BASE + '/open'

        return WsService.get(url, params, 200).then(
            response => {
                let conversations = [];
                response.forEach(conversation => {
                    conversations.push(new ChatConversationDTO(conversation))
                })
                return conversations;
            },
            error => {
                return error;
            }
        )
    }

    static retrieveOpenForUserAndContext(userId, resourceType, resourceId) {

        let params = {
            'resource-type': resourceType,
            'resource-id': resourceId,
            'user-id': userId,
        }

        let url = ENDPOINT_BASE + '/open'

        return WsService.get(url, params, 200).then(
            response => {
                let conversations = [];
                response.forEach(conversation => {
                    conversations.push(new ChatConversationDTO(conversation))
                })
                return conversations;
            },
            error => {
                return error;
            }
        )
    }

    static retrieveClosedForUser(userId) {
        let params = {
            'user-id': userId,
        }

        let url = ENDPOINT_BASE + '/closed'

        return WsService.get(url, params, 200).then(
            response => {
                let conversations = [];
                response.forEach(conversation => {
                    conversations.push(new ChatConversationDTO(conversation))
                })
                return conversations;
            },
            error => {
                return error;
            }
        )
    }

    static retrieveClosedForUserAndContext(userId, resourceType, resourceId) {
        let params = {
            'resource-type': resourceType,
            'resource-id': resourceId,
            'user-id': userId,
        }

        let url = ENDPOINT_BASE + '/closed'

        return WsService.get(url, params, 200).then(
            response => {
                let conversations = [];
                response.forEach(conversation => {
                    conversations.push(new ChatConversationDTO(conversation))
                })
                return conversations;
            },
            error => {
                return error;
            }
        )
    }

    static retrieveConversation(conversationId) {

        return WsService.get(ENDPOINT_BASE + '/' + conversationId, 200).then(
            response => {
                return new ChatConversationDTO(response)
            },
            response => {
                return response;
            }
        );
    }

    static retrieveUnreadConversationsForUser(id) {
        let url = ENDPOINT_BASE + "/unread";
        let params = {'user-id': id}

        return WsService.get(url, params, 200).then(
            response => {
                let toReturn = [];
                response.forEach(conversation => {
                    toReturn.push(new ChatConversationDTO(conversation))
                })
                return toReturn;
            },
            error => {
                return error;
            }
        )
    }

    static retrieveUnreadConversationCountForUser(id) {
        let url = ENDPOINT_BASE + "/unread/count";
        let params = {'user-id': id}

        return WsService.get(url, params, 200).then(
            response => {
                return new CountResponse(response);
            },
            error => {
                return error;
            }
        )
    }

}